import { FormikHelpers } from "formik";
import { fromJS } from "immutable";
import { DestinationAddressResponseDto } from "types/api/destination_addresses";
import { OpenRightPanel } from "types/common/rightPanel";
import { ChangingAddressFormValues } from "types/OutgoingForms/changingAddressPanel";
import { toastResponseError } from "utils/responseMessageHelper";
import * as yup from "yup";

export const changingAddressPanelFormik = (
  panelData: any,
  destinations: any,
  updateAddress: (
    id: string,
    data: { destination_address: any },
  ) => Promise<any>,
  setCartAddress: (data: { id: number }) => Promise<any>,
  openRightPanel: OpenRightPanel,
  // An address the address panel just added (ChangingAddressPanel submits it
  // on mount): preselected, and used for the save if the list lacks it.
  addedAddress?: DestinationAddressResponseDto,
) => {
  return {
    initialValues: {
      addressId: addedAddress ? addedAddress.id : panelData.get("addressId"),
    },
    validationSchema: () =>
      yup.object().shape({
        addressId: yup.string().required(),
      }),
    onSubmit: (
      values: ChangingAddressFormValues,
      { setSubmitting }: FormikHelpers<ChangingAddressFormValues>,
    ) => {
      const isCartVariant = panelData.get("isCartVariant");
      // The list is refetched when the picker mounts and may not include the
      // address added a moment ago: fall back to the copy the panel handed over.
      const selectedAddress =
        destinations.find(
          (destination: any) => destination.get("id") === values.addressId,
        ) ??
        (addedAddress && addedAddress.id === values.addressId
          ? fromJS(addedAddress)
          : undefined);
      const updateMethod = isCartVariant
        ? setCartAddress({ id: values.addressId })
        : updateAddress(panelData.get("detailedItemID"), {
            destination_address: selectedAddress,
          });

      updateMethod
        .then(() => {
          if (panelData.get("setAccess")) {
            panelData.get("setAccess")();
          }
          openRightPanel(panelData.get("returnPreviousPanel"), panelData);
        })
        .catch(toastResponseError)
        .finally(() => setSubmitting(false));
    },
  };
};
